import Rejected from './Rejected';

export default Rejected;
